module.exports = __webpack_public_path__ + "media/images/aboutus/bg-cover-2c97b1486b67647ef6bb3034363541dd.png";